import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import "./index.css";
import { ExternalPageHeader } from "../../components/Header/ExternalHeader";
import 'animate.css';
import authService from "../../services/auth-service"
import { HeroSection } from "../../components/Header/Hero"
import { Services } from "../../components/Services/Index"
import { Reviews } from "../../components/Reviews/Index"
import { Caution } from "../../components/Caution/index"
import { HowItWorks } from "../../components/Hiw/index"
import { ReachOut } from "../../components/ReachOut/index"
import { Patners } from "../../components/Partners/index"
import { Footer } from "../../components/Footer/index"
import { FooterMobile } from "../../components/Footer/Footer-mobile"
import { error, success } from "../../components/Alerts/Index"
import successGifImage from "../../assets/success-blue.gif"
import { Modal } from 'antd'
export const Landing = () => {
  const [fname, setFname] = useState("")
  const [load, setLoad] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [skill, setSkill] = useState("")
  const [showMain, setShowMain] = useState(true)
  const joinWaitlist = async (e) => {
    e.preventDefault()
    if (!email) {
      error("Error", "Email is required to join wait list")
      return;
    }

    setLoad(true)
    const data = {
      "emailAddress": email,
      "phoneNumber": "test",
      "fullName": "test",
      "skill": "test"
    }
    try {
      const result = await authService.joinlist(data);
      if (result) {
        setLoad(false)
        setOpenModal(true)
      }
    } catch (err) {
      setLoad(false)

    }
  }

  const clearForms = () => {
    setEmail("")
    setPhone("")
    setFname("")
    setSkill("")
    setOpenModal(false)
  }

  const gotoService = () => {

  }

  const gotoReviews = () => {

  }

  const gotoContact = () => {

  }

  const gotoHowitWorks = () => {
    
  }


  return (
    <div>
      <div className="">
        <ExternalPageHeader />
        <HeroSection joinWaitlist={joinWaitlist} load={load} setEmail={setEmail} />
        <Services />
        <Patners />
        <Reviews />
      </div>
      <HowItWorks />
      <div className="container-art">
        <ReachOut />
      </div>
      <div className="show-web-int">
        <Footer />
      </div>
      <div className="show-mobile-int">
        <FooterMobile />
      </div>
      <Modal title="" open={openModal} onOk={clearForms} onCancel={clearForms} footer={false}>
        <div className="d-flex justify-content-center">
          <div>
            <div className="text-center">
              <img src={successGifImage} width={"50%"} />
            </div>
            <p className="text-center">Thank you for joining our waitlist! We’ll be launching soon to serve you, and you’ll be among the first to know when we go live.</p>

          </div>
        </div>
      </Modal>
    </div>

  );
};
